// extracted by mini-css-extract-plugin
export default {"Container":"_Container--UVXUd","YAxisLabelButton":"_YAxisLabelButton--MEVRs","Label":"_Label--T9lYs","DocumentCount":"_DocumentCount--AO6f_","Static":"_Static--ApPtC"};